import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, TypographyVariants } from '@lyearn/ui';
import { LinkButton } from '@lyearn/ui';

import { GroupedActionItem } from '../../../types';

interface LoadMoreProps {
  variant?: TypographyVariants;
  fetchMoreActionItems: (groupedActionItem: GroupedActionItem) => void;
  groupedActionItem: GroupedActionItem;
  className?: string;
}

function LoadMore({ variant, fetchMoreActionItems, groupedActionItem, className }: LoadMoreProps) {
  const { t } = useTranslation();
  const onLoadMore = useCallback(
    () => fetchMoreActionItems(groupedActionItem),
    [fetchMoreActionItems, groupedActionItem],
  );

  return (
    <Stack className={className}>
      <LinkButton typography={variant ? { variant } : undefined} onClick={onLoadMore}>
        {t('Task:LoadMore')}
      </LinkButton>
    </Stack>
  );
}

export default React.memo(LoadMore);
